<c-card *transloco="let t">
    <c-card-body class="px-2">

      <app-worker-reports-menu></app-worker-reports-menu>

        <div class="row">
          <div class="col-sm-6">
            <h3>{{ t('Report: Alert Loop List') }}</h3>
            <p> {{ t('A list of all the workers in your account and the Alert Loop assigned.') }}</p>
          </div>
          <div class="col-sm-6 text-end">
            <button type="button" class="btn btn-light" aria-expanded="false" (click)="export()">
              <i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}
            </button>
          </div>
        </div>

          <c-row *ngIf="workers">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">{{ t('PIN') }}</th>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Alert Loop') }}</th>
                    <!-- <th scope="col">{{ t('Email') }} / {{ t('Phone') }}</th> -->
                    <!-- <th scope="col">{{ t('Monitors') }}</th>
                    <th scope="col">{{ t('Groups') }}</th> -->
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let worker of workers" [ngClass]="{'table-info': worker.alert_loop != 'None' }">
                        <td>
                            <button color="info" cButton class="me-1 btn-sm text-white" routerLink="/mgmt/worker/{{worker.id}}">
                              <svg cIcon class="me-2" name="cil-pencil"></svg>
                              {{ t('Edit') }}
                            </button>
                        </td>

                        <th scope="row">
                            <span class="badge bg-light text-dark">{{worker.pin}}</span>
                        </th>
                      <td>
                        <span><b>{{worker.name}}</b></span>
                      </td>
                      <td>
                        {{worker.alert_loop}}
                      </td>
                      <!-- <td>
                        {{worker.email}}
                        <div class="small text-medium-emphasis">
                          <span>{{worker.phone}} <span *ngIf="worker.phone && worker.cell">/</span> {{worker.cell}}</span>
                        </div>
                      </td> -->
                      <!-- <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.monitors}}</span>
                        </div>
                      </th>
                      <th>
                        <div class="small text-medium-emphasis">
                          <span>{{worker.groups}}</span>
                        </div>
                      </th> -->

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

    </c-card-body>
  </c-card>
